import NumberFormat from "react-number-format";

import type { PropertyListing } from "@gql";

interface Props {
  propertyListing: Pick<PropertyListing, "lease" | "leasePerUnit" | "leasePerTime" | "price">;
}

const PropertyListingPrice = ({ propertyListing }: Props) => {
  const renderNumberFormat = (value: string, testId?: string) => {
    return (
      <NumberFormat
        data-testid={testId}
        displayType="text"
        prefix="$"
        value={value}
        thousandSeparator
      />
    );
  };

  const renderLease = () => {
    if (!propertyListing.lease) return null;

    return (
      <span data-testid="lease">
        {renderNumberFormat(propertyListing.lease)}/
        {propertyListing.leasePerUnit || propertyListing.leasePerTime}
      </span>
    );
  };

  const renderPrice = () => {
    if (!propertyListing.price) return null;
    return renderNumberFormat(propertyListing.price, "price");
  };

  return (
    <div className="property-listing-price-component">
      {renderLease()}
      {renderPrice()}
    </div>
  );
};

export { PropertyListingPrice, type Props };
